<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> کار در منزل های رزرو شده </template>
    <template #titleBtn>
      <BButton variant="success" to="/master/schedule">
        ساخت تایم کار در منزل جدید
      </BButton>
    </template>
    <BRow>
      <BCol
        class="my-1"
        cols="12"
        md="6"
        v-for="(homework, index) in reservedHomeworksList"
        :key="index"
      >
        <AppCollapse accordion type="border">
          <AppCollapseItem :title="accordionTitle(homework)">
            <hr style="margin-top: 0rem !important" />
            <ReservedHomeworkCard
              :reservationDetails="homework.homeWorksReservedForShow"
              :reservationDate="homework.date"
            ></ReservedHomeworkCard>
          </AppCollapseItem>
        </AppCollapse>
      </BCol>
    </BRow>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getAllHomeworksPerDate();
  },
  data() {
    return {
      isLoading: false,
      reservedHomeworksList: null,
      totalCount: null,
      reservedHomeworksFilters: {
        searchCommand: null,
        masterUserId: null,
        studentUserId: null,
        justForToday: null,
        page: 1,
        count: 10,
      },
    };
  },
  methods: {
    accordionTitle(homework) {
      return `${this.customConvertWeekDay(
        homework.date
      )} - ${this.customFullDateConvert(homework.date)} (${
        homework.totalReserveTime
      } دقیقه)`;
    },
    async getAllHomeworksPerDate() {
      try {
        this.reservedHomeworksFilters.masterUserId = getUserData().user.userId;
        this.isLoading = true;
        const _this = this;
        const getAllReservedHomeworksPerDate =
          new GetAllReservedHomeworksPerDate(_this);
        getAllReservedHomeworksPerDate.setRequestParamDataObj(
          _this.reservedHomeworksFilters
        );
        await getAllReservedHomeworksPerDate.fetch((res) => {
          _this.reservedHomeworksList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    ReservedHomeworkCard,
    BButton,
    BRow,
    BCol,
    AppCollapse,
    AppCollapseItem,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import ReservedHomeworkCard from "@/views/components/Homeworks/ReservedHomeworkCard.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BRow, BCol, BButton } from "bootstrap-vue";

import { getUserData } from "@/auth/utils";
import { GetAllReservedHomeworksPerDate } from "@/libs/Api/HomeWorks";
</script>
